var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 157,
    viewBox: "0 0 156 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9850_27417)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9850_27417)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.349609,
    width: 156,
    height: 156,
    rx: 78,
    fill: "#EEEEF4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9850_27417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.516 56.9995V144.154C144.516 148.65 140.869 152.299 136.376 152.299H20.0369C15.5435 152.299 11.897 148.65 11.897 144.154V56.9995C11.897 52.503 15.5435 48.8545 20.0369 48.8545H136.375C140.869 48.8545 144.516 52.503 144.516 56.9995Z",
    fill: "#E4EAF7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.7069 55.7876C22.7069 56.9096 21.7973 57.8193 20.6753 57.8193C19.5532 57.8193 18.6436 56.9096 18.6436 55.7876C18.6436 54.6655 19.5532 53.7559 20.6753 53.7559C21.7973 53.7559 22.7069 54.6655 22.7069 55.7876Z",
    fill: "#FF6469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7333 55.7876C29.7333 56.9096 28.8237 57.8193 27.7016 57.8193C26.5795 57.8193 25.6699 56.9096 25.6699 55.7876C25.6699 54.6655 26.5795 53.7559 27.7016 53.7559C28.8237 53.7559 29.7333 54.6655 29.7333 55.7876Z",
    fill: "#FFB96A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.515 61.9967H88.8647C86.7763 61.9967 84.7972 61.0639 83.4687 59.4521L76.8293 51.4001C75.5008 49.7883 73.5217 48.8555 71.4344 48.8555H53.8462C51.773 48.8555 49.8071 49.7752 48.4786 51.3678L41.7016 59.4844C40.3721 61.077 38.4061 61.9967 36.333 61.9967H11.8979V78.6217H144.515V61.9967Z",
    fill: "#BEC8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7607 55.7876C36.7607 56.9096 35.8511 57.8193 34.729 57.8193C33.6069 57.8193 32.6973 56.9096 32.6973 55.7876C32.6973 54.6655 33.6069 53.7559 34.729 53.7559C35.8511 53.7559 36.7607 54.6655 36.7607 55.7876Z",
    fill: "#A7D16C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.895 70.4321C130.895 71.5542 129.986 72.4638 128.864 72.4638C127.742 72.4638 126.832 71.5542 126.832 70.4321C126.832 69.31 127.742 68.4004 128.864 68.4004C129.986 68.4004 130.895 69.31 130.895 70.4321Z",
    fill: "#54A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.022 70.4321C139.022 71.5542 138.112 72.4638 136.99 72.4638C135.868 72.4638 134.958 71.5542 134.958 70.4321C134.958 69.31 135.868 68.4004 136.99 68.4004C138.112 68.4004 139.022 69.31 139.022 70.4321Z",
    fill: "#54A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0541 72.4658H22.5727C21.4506 72.4658 20.541 71.5552 20.541 70.4331C20.541 69.31 21.4506 68.4004 22.5727 68.4004H89.0541C90.1762 68.4004 91.0858 69.31 91.0858 70.4331C91.0858 71.5552 90.1762 72.4658 89.0541 72.4658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.346 59.332H54.9848C53.8627 59.332 52.9531 58.4214 52.9531 57.2993C52.9531 56.1762 53.8617 55.2666 54.9848 55.2666H70.346C71.4681 55.2666 72.3777 56.1762 72.3777 57.2993C72.3777 58.4214 71.4681 59.332 70.346 59.332Z",
    fill: "#0037C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.469 151.941C132.448 148.53 132.111 145.198 131.487 141.966C127.329 120.372 110.389 103.336 88.8581 99.0492C85.5313 98.3854 82.0952 98.0272 78.5772 98.005C78.4527 98.002 78.3313 98.002 78.2069 98.002C78.0824 98.002 77.961 98.002 77.8366 98.005C74.3256 98.0272 70.8915 98.3854 67.5678 99.0461C46.0306 103.329 29.0819 120.372 24.9224 141.972C24.3031 145.201 23.9662 148.533 23.945 151.941C23.9409 152.059 23.9409 152.181 23.9409 152.299H132.473C132.473 152.181 132.473 152.059 132.469 151.941Z",
    fill: "#D2DCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.388 151.988C125.369 149.023 125.076 146.126 124.535 143.315C120.919 124.539 106.19 109.726 87.4688 105.999C84.5761 105.422 81.5872 105.11 78.5286 105.091C78.4203 105.088 78.3151 105.088 78.2068 105.088C78.0986 105.088 77.9933 105.088 77.8851 105.091C74.8314 105.109 71.8466 105.422 68.9559 105.995C50.2285 109.72 35.4926 124.539 31.8754 143.32C31.3371 146.128 31.0437 149.025 31.0255 151.988C31.0225 152.091 31.0225 152.197 31.0225 152.3H125.391C125.391 152.196 125.391 152.091 125.388 151.988Z",
    fill: "#D7C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.388 151.988C125.369 149.023 125.076 146.126 124.535 143.315C123.284 141.439 121.631 139.647 119.605 137.972C115.211 134.348 109.146 131.353 102.007 129.279C98.8729 118.275 93.6641 110.097 87.4688 105.999C84.5761 105.421 81.5872 105.109 78.5286 105.09C78.4203 105.088 78.3151 105.088 78.2068 105.088C78.0986 105.088 77.9933 105.088 77.8851 105.09C74.8314 105.109 71.8466 105.421 68.9559 105.995C62.7556 110.091 57.5428 118.272 54.4062 129.279C47.2679 131.355 41.2032 134.348 36.812 137.974C34.7803 139.649 33.13 141.444 31.8764 143.32C31.3371 146.128 31.0447 149.025 31.0255 151.988C31.0225 152.091 31.0225 152.196 31.0225 152.3H125.391C125.391 152.196 125.391 152.091 125.388 151.988ZM51.3587 150.267H33.2515C33.8798 147.069 35.9742 143.935 39.3961 141.111C42.899 138.221 47.6413 135.758 53.2467 133.898C52.1145 139.102 51.4801 144.589 51.3587 150.267ZM76.1751 150.267H55.4221C55.5657 144.135 56.3509 138.086 57.7249 132.587C63.4355 131.131 69.7522 130.299 76.1751 130.154V150.267ZM76.1751 126.086C70.2611 126.216 64.421 126.902 59.0109 128.103C60.905 122.286 63.4568 117.353 66.48 113.707C69.4547 110.119 72.7724 107.939 76.1751 107.313V126.086ZM80.2385 107.313C83.6361 107.936 86.9569 110.116 89.9336 113.707C92.9569 117.353 95.5086 122.285 97.4027 128.102C91.9926 126.902 86.1525 126.216 80.2385 126.086V107.313ZM80.2385 150.267V130.154C86.6614 130.299 92.9791 131.131 98.6887 132.587C100.063 138.086 100.848 144.135 100.992 150.267H80.2385ZM105.055 150.267C104.934 144.586 104.299 139.103 103.167 133.898C108.772 135.755 113.518 138.218 117.019 141.108C120.439 143.93 122.534 147.063 123.159 150.267H105.055Z",
    fill: "#C695ED"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.34961,
    width: 152,
    height: 152,
    rx: 76,
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9850_27417",
    x: -12.3667,
    y: 28.6348,
    width: 181.146,
    height: 151.972,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.04395
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.1318
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.541176 0 0 0 0 0.596078 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9850_27417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9850_27417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9850_27417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    fill: "white",
    transform: "translate(0 0.349609)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9850_27417"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.349609,
    width: 156,
    height: 156,
    rx: 78,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApp);
export default __webpack_public_path__ + "static/media/web-app.a41d383af3079e5d28da18734c4be572.svg";
export { ForwardRef as ReactComponent };